import request from '@/plugin/axios'

export function FetchAuth () {
  return request({
    url: '/auth-item/list-auth',
    method: 'post'
  })
}

export function ListRoles (data) {
  return request({
    url: '/auth-role/index',
    method: 'get',
    params: data
  })
}

export function GetAssistItems () {
  return request({
    url: '/auth-role/assist-items',
    method: 'get'
  })
}

export function CreateRole (data) {
  return request({
    url: '/auth-role/create',
    method: 'post',
    data
  })
}

export function ViewRole (item) {
  return request({
    url: '/auth-role/view?id=' + item,
    method: 'get'
  })
}

export function UpdateRole (data) {
  return request({
    url: '/auth-role/update?id=' + data.role,
    method: 'post',
    data
  })
}

export function DeleteRole (item) {
  return request({
    url: '/auth-role/delete?id=' + item,
    method: 'delete'
  })
}

export function CreateModule (data) {
  return request({
    url: '/auth-item/create',
    method: 'post',
    data
  })
}

export function ViewModule (item) {
  return request({
    url: '/auth-item/view?item=' + item,
    method: 'get'
  })
}

export function EditModule (data) {
  return request({
    url: '/auth-item/update?item=' + data.item,
    method: 'post',
    data
  })
}

export function ListItems (data) {
  return request({
    url: '/auth-item/list-items',
    method: 'get',
    params: data
  })
}

export function DeleteItem (item) {
  return request({
    url: '/auth-item/delete?item=' + item,
    method: 'delete'
  })
}

export function ListItemsByRole (role) {
  return request({
    url: '/auth-role/list-auth-by-role?role=' + role,
    method: 'get'
  })
}

export function AuthItem (role, data) {
  return request({
    url: '/auth-role/auth?role=' + role,
    method: 'post',
    data
  })
}
